import React from 'react';
import { useRouteError, Link } from 'react-router-dom';
import { Layout, Result, Button } from 'antd';
import error500 from 'img/error500.svg';

import ErrorNavbar from 'src/views/navbar/errorNavbar';

const RouterErrorBoundary = () => {
	const error = useRouteError();
	console.error('RouterErrorBoundary', error);

	return (
		<>
			<ErrorNavbar />
			<Layout
				style={{
					// inline styles are used to keep the component as simple as possible
					height: 'calc(100vh - 64px)',
					backgroundImage: `url(${error500})`,
					backgroundPosition: 'center center',
					marginTop: '64px',
				}}
			>
				<Result
					style={{ margin: 'auto' }}
					status='500'
					title='Something went wrong.'
					subTitle={
						<div>
							<p style={{ color: 'black' }}>Error: {error.toString()}</p>
						</div>
					}
					extra={
						<Link to='/'>
							<Button type='primary'>Back Home</Button>
						</Link>
					}
				/>
			</Layout>
		</>
	);
};

export default RouterErrorBoundary;
